<template>
  <div class="yxtbiz-lib-selector yxtbiz-lib-flex">
    <!-- 左侧题库tree -->
    <div class="yxtbiz-lib-selector__left">
      <div class="yxtbiz-lib-flex">
        <!-- 有公开题库/私密题库的创建权限 -->
        <div v-if="needCreateLib && (checkActionAdminPermission('questionBank_add_oepn_operate') || checkActionAdminPermission('questionBank_add_private_operate'))" class="col-flex-1">
          <yxt-button class="mr12" type="primary" @click="openLibDetailDrawer">{{ $t('pc_ote_btn_createquestionlib' /* 新建题库 */) }}</yxt-button>
        </div>
        <catalogDropdown
          class="mr12 width144 d-in-block"
          size="small"
          :data="catalogDatas"
          :dropToolTip="$t('pc_biz_ote_lbl_classification')"
          :catalogId.sync="params.catalogId"
          :catalogName.sync="params.catalogName"
          @change="catalogChange"></catalogDropdown>
        <yxt-input
          v-model="params.keyword"
          :placeholder="$t('pc_biz_ote_lbl_queslibsearch')"
          class="d-in-block"
          :class="$isChinese ? 'width240' : 'width280'"
          size="small"
          searchable
          @search="search">
        </yxt-input>
      </div>

      <yxt-table
        ref="libTable"
        v-loading="quesLoading"
        :data="quesTableList"
        :height="tableHeight"
        class="mt16 width-percent-100 yxtbiz-lib-selector__left-table"
        :default-sort="tableDefaultSort"
        :row-key="getRowKey"
        @radio-change="radioChange"
        @selection-change="selectionChange"
        @sort-change="sortChange">
        <yxt-table-column v-if="needMutiple"
                          type="selection"
                          width="32"
                          reserve-selection />
        <yxt-table-column v-else type="radio" width="32" />
        <!-- 题库名称 -->
        <yxt-table-column prop="name"
                          :label="$t('pc_biz_ote_lbl_quesbankname')"
                          :min-width="200"
                          :show-overflow-tooltip="false">
          <template slot-scope="scope">
            <div class="yxtbiz-table-row">
              <yxt-tooltip :content="scope.row.name"
                           open-filter
                           class="yxtbiz-table-row__name"
                           placement="top"
                           :max-width="500">
                <span class="font-size-14 ellipsis">{{ scope.row.name }}</span>
              </yxt-tooltip>
              <!-- 保密标识 -->
              <yxt-tag v-if="scope.row.secrecy === 1"
                       key="保密"
                       type="warning"
                       size="mini"
                       class="ml8 yxtbiz-table-row__tag">
                {{ $t('pc_ote_tip_secrecy') }}
              </yxt-tag>
              <!-- 共享标识 -->
              <yxt-tooltip class="ml8" :content="getShareInfor(scope.row)" placement="top">
                <yxt-svg icon-class="icon-share" v-if="scope.row.shared === 1"
                        width="18px"
                        height="18px"
                        class="hand yxtbiz-table-row__tag"
                        :remote-url='mediaUrl' />
              </yxt-tooltip>
              <!-- 共享中心tag标识 -->
              <yxt-tag
                v-if="scope.row.shareSourceType === 1"
                key="集团标识"
                type="warning"
                size="mini"
                class="ml8 yxtbiz-table-row__tag">
                {{ $t('pc_biz_ote_btn_share') }}
              </yxt-tag>
            </div>
          </template>
        </yxt-table-column>

        <!-- 创建人 -->
        <yxt-table-column prop="createFullname"
                          :label="$t('pc_biz_lbl_creator'/*创建人*/)"
                          :width="160"
                          :show-overflow-tooltip="true"
                          :popover-html="true"
        >
          <template slot-scope="scope">
            <yxtbiz-user-name :name="scope.row.createFullname || '--'" />
            <template v-if="scope.row.createFullname">
              (<yxtbiz-user-name :name="scope.row.createUserName" />)
            </template>
          </template>
        </yxt-table-column>

        <!-- 更新日期 -->
        <yxt-table-column
          prop="updateTime"
          :label="$t('pc_biz_ote_lbl_updatetime')"
          :width="140"
          :formatter="shortDate"
          sortable="custom"
          align="center" />
      </yxt-table>

      <!-- 分页控件 -->
      <div class="mt16 text-right">
        <yxt-pagination
          :page-size="pager.limit"
          :total="pager.count"
          :current-page="pager.current"
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange" />
      </div>
    </div>

    <!-- 右侧题库列表 -->
    <div class="yxtbiz-lib-flex flex-col flex-g-1 pt24 pl24 pr24">
      <div class="yxtbiz-lib-flex flex-between">
        <span>{{ $t('pc_ote_lbl_choosed_queslib_text' /* 已选题库 */) }}</span>
        <yxt-button v-if="needMutiple && checkedInfo.length" type="text" @click="clearAllQus">{{ $t('pc_biz_ote_lbl_clearall') }}</yxt-button>
      </div>

      <div v-if="checkedInfo.length" class="mt16 mfl8" :class="{'yxtbiz-lib-selector__right--qus flex-g-1': needMutiple}">
        <yxt-scrollbar ref="rightScrollbar" class="yxtbiz-hp100">
          <yxt-tag
            v-for="info in checkedInfo"
            :key="info.id"
            size="small"
            type="info"
            closable
            :disable-transitions="true"
            class="yxtbiz-lib-selector__right--tag ml8 mb8"
            @close="handleClose(info)">
            <div class="flex">
              <yxt-tooltip :content="info.name" placement="top" open-filter>
                <span class="ellipsis">{{ info.name }}</span>
              </yxt-tooltip>
            </div>
          </yxt-tag>
        </yxt-scrollbar>
      </div>

      <!-- 只有单选题库才显示考核点设置 -->
      <yxt-form v-if="needPointSet && !needMutiple && checkedInfo.length"
                :model="ruleForm"
                :rules="rules"
                label-position="top"
                class="mt16"
                size="small"
                isNeedRequire>
        <yxt-form-item :label="$t('pc_ote_btn_batchsetpoints' /* 设置考核点 */)" prop="points">
          <yxt-radio-group v-model="ruleForm.points" direction="row" @change="changeRadioGroup">
            <yxt-radio label="0">{{ $t('pc_ote_lib_transfer_points_radio1' /* 统一到所选的考核点下 */) }}</yxt-radio>
            <div v-show="ruleForm.points === '0'" class="bg-gray-1 pv16 ph16">
              <ques-point-selector
                v-model="ruleForm.pointLists"
                :libId="checkedInfo[0].id"
                class="clazz_width_100"
                selectSize="small"
                selectClass="clazz_width_100"
                :multiple-limit="5"
              />
            </div>
            <yxt-radio label="1">{{ $t('pc_ote_lib_transfer_points_radio2' /* 试题考核点复制到所选题库 */) }}</yxt-radio>
          </yxt-radio-group>
        </yxt-form-item>
      </yxt-form>
    </div>

    <!-- 新建试题库 -->
    <yxt-drawer :title="$t('pc_ote_btn_createquestionlib')"
                size="640px"
                :visible.sync="libDetail.isShowDrawer"
                :before-close="done =>done($refs['libEditor'].isChange)"
                :destroyOnClose="true">
      <QuesLibDetail v-if="libDetail.isShowDrawer"
                     ref="libEditor"
                     :catalogId="libDetail.catalogId"
                     :catalogName="libDetail.catalogName"
                     :createType="createType"
                     @closeLibDrawer="closeLibDrawer"
                     @search="setCreateVal"
                     @saveBtnStatus="saveBtnStatus" />
      <div slot="footer">
        <yxt-button plain @click="closeLibDrawer">{{ $t('pc_biz_ote_btn_cancle') }}</yxt-button>
        <yxt-button type="primary"
                    :disabled="libDetail.btnDisabled"
                    :loading="libDetail.btnDisabled"
                    @click="save">
          {{ $t('pc_biz_ote_btn_confirm') }}
        </yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
import CatalogDropdown from 'packages/question-selector/src/selector/catalogDropdown.vue';
import QuesPointSelector from 'packages/intelligent-questioning/src/ques/quesPointSelector.vue';
import QuesLibDetail from './components/QuesLibDetail.vue';
import { getCatalogList, postQuesLibList } from './service';
import { dateToString } from 'packages/question-selector/src/utils.js';
import rootCatalog from 'packages/question-selector/src/selector/rootCatalog.js';
import resizeTable from 'packages/exam-arrange-selector/mixins/resizeTable.js';
import utils from './utils';
import { scrollbarWidth } from 'yxt-pc';

export default {
  name: 'YxtbizLibSelector',
  name_zh: '题库选择组件',
  components: {
    CatalogDropdown,
    QuesPointSelector,
    QuesLibDetail
  },
  eventList: [{
    type: 'selectLibCallback',
    handler: 'confirmLib',
    label: '选中某个或多个题库后的回调'
  }, {
    type: 'closeSelectLibDrawer',
    handler: 'close',
    label: '关闭选择题库抽屉'
  }],
  mixins: [rootCatalog, resizeTable],
  props: {
    states: {
      type: Object,
      default: () => ({}),
      desc: '用来回显的数据对象，包含libId、libName、max',
      setter: 'JsonSetter'
    },
    // 创建题库的类型, 0:题库-建库; 1:组卷-建库; 默认0
    createType: {
      type: Number,
      default: 0,
      desc: '创建题库的类型, 0:题库-建库; 1:组卷-建库;',
      setter: 'TabSetter',
      enums: [{
        label: '题库-建库',
        value: 0
      }, {
        label: '组卷-建库',
        value: 1
      }]
    },
    // 是否需要设置考核点
    needPointSet: {
      type: Boolean,
      default: false,
      desc: '是否需要设置考核点',
      setter: 'BooleanSetter'
    },
    // 是否需要新建题库
    needCreateLib: {
      type: Boolean,
      default: false,
      desc: '是否需要新建题库',
      setter: 'BooleanSetter'
    },
    // 是否需要多选题库
    needMutiple: {
      type: Boolean,
      default: false,
      desc: '是否需要多选题库',
      setter: 'BooleanSetter'
    },
    // 最多允许选择试题的数量
    maxQuesTotal: {
      type: Number,
      default: 1000,
      desc: '最多允许选择试题的数量',
      setter: 'NumberSetter'
    }
  },
  data() {
    return {
      refTable: 'libTable',
      tableHeight: 400,
      catalogDatas: this.wrapRootCatalog(),
      // 老的mediasvg迁移后的地址
      mediaUrl: 'https://stc.yxt.com/ufd/55a3e0/ote/pc/other/ote/svg',
      quesLoading: true,
      quesTableList: [],
      tableDefaultSort: {
        prop: 'updateTime',
        order: 'desc'
      },
      pager: {
        limit: 20,
        count: 0,
        current: 1,
        orderby: 'updateTime',
        direction: 'desc'
      },

      filterCatalog: {}, // 筛选分类后的catalog信息
      params: {
        keyword: '',
        disabled: 0,
        scope: 4, // 排除【共享给我】无管辖权限的数据
        catalogId: '',
        catalogName: '',
        routingPath: '',
        isComponent: 1
      },

      // 左侧选中的题库
      checkedInfo: [],
      ruleForm: {
        points: '0',
        pointLists: []
      },
      rules: {
        points: [{ required: true }]
      },
      libDetail: {
        isShowDrawer: false,
        btnDisabled: false,
        catalogId: 'root',
        catalogName: this.$t('pc_biz_ote_lbl_defaultqueslibcatalog')
      }
    };
  },

  computed: {
    // 给外部作为是否更改内部id使用
    isChangeCheck() {
      if (this.needMutiple) {
        return !!this.checkedInfo.length;
      }
      return this.states.libId !== ((this.checkedInfo[0] && this.checkedInfo[0].id) || '');
    },
    gutter() {
      return scrollbarWidth();
    },
    scrollWrapHeight() {
      return `calc(100% + ${this.gutter}px)`;
    }
  },

  created() {
    if (this.states.libId && !this.needMutiple) {
      this.checkedInfo = [{
        id: this.states.libId,
        name: this.states.libName
      }];
    }
    this.setCatalogType(0);
    this.getLibCatalog();
    this.search();
  },

  watch: {
    checkedInfo(v) {
      if (v.length) {
        this.$nextTick(() => {
          if (this.$refs.rightScrollbar) {
            this.$refs.rightScrollbar.$el.querySelector('.yxt-scrollbar__wrap').style.height = this.scrollWrapHeight;
          }
        });
      }
    }
  },

  methods: {
    // 默认题库走题库导航的权限
    checkActionAdminPermission(fc, ac) {
      if (!ac) {
        ac = fc;
        fc = 'ote_ques_lib_mgmt';
      }
      return utils.checkActionAdminPermission(fc, ac, this);
    },
    // 试题库分类树
    getLibCatalog() {
      const params = { disabled: 0, navCode: 'ote_ques_lib_mgmt' };
      getCatalogList(params).then(catalogs => {
        this.catalogDatas = this.initCatalogList(catalogs);
      }).catch(this.handleError);
    },
    // 点击分类搜索题库
    catalogChange(data) {
      this.filterCatalog = data;
      this.params.catalogId = data.id;
      this.params.routingPath = data.routingPath;
      this.search();
    },

    sortChange(sort) {
      this.pager.direction = sort.order || '';
      this.pager.orderby = sort.prop;
      this.search();
    },

    search() {
      this.pager.current = 1;
      this.getPages();
    },

    // 多选时表格的选中
    setSelectionChoosed() {
      const ids = this.checkedInfo.map(item => item.id);
      this.quesTableList.forEach(item => {
        if (ids.includes(item.id)) {
          this.$nextTick(() => {
            this.$refs.libTable.toggleRowSelection(item, true);
          });
        }
      });
    },

    // 单选时表格的选中
    setRadioChoosed() {
      const checkId = (this.checkedInfo[0] && this.checkedInfo[0].id) || '';
      this.quesTableList.forEach(item => {
        if (item.id === checkId) {
          this.$nextTick(() => {
            this.$refs.libTable.toggleRowCurrentRadio(item, true);
          });
        }
      });
    },

    // 获取列表数据
    getPages() {
      this.quesLoading = true;
      const { current, limit, orderby, direction } = this.pager;
      this.params.keyword = this.params.keyword.trim();
      postQuesLibList({ current, limit, orderby, direction }, this.params).then(res => {
        this.quesTableList = res.datas;

        if (this.checkedInfo.length) {
          this.needMutiple ? this.setSelectionChoosed() : this.setRadioChoosed();
        }

        this.pager.count = res.paging.count;
        this.quesLoading = false;
      }).catch(() => {
        this.quesLoading = false;
      });
    },

    handleCurrentChange(val) {
      this.pager.current = val;
      this.getPages();
    },

    getShareInfor({ sharedFullname, sharedUsername }) {
      const username = sharedUsername ? `（${sharedUsername}）` : '';
      return `${sharedFullname}${username}${this.$t('pc_biz_ote_btn_share' /* 共享 */)}`;
    },

    // 日期格式转换
    shortDate(row, col, val, index) {
      return !val ? '-' : dateToString(val, 'yyyy-MM-dd');
    },

    // 确定选中的题库
    confirmLib() {
      if (!this.checkedInfo.length) {
        this.$message.warning(this.$t('pc_ote_lbl_selqueslib_first' /* 请先选择题库 */));
        return;
      }

      try {
        const quesTotal = this.checkedInfo.reduce((total, item) => total + (item.totalQuesQty || 0), 0);
        // 默认最多3000个试题
        if (this.needMutiple && quesTotal > this.maxQuesTotal) {
          this.$message.warning(this.$t('pc_ote_msg_quesliblimitmax', [this.maxQuesTotal]));
          return;
        }
      } catch (error) {
        console.log(error);
      }

      if (this.needMutiple) {
        this.$emit('selectLibCallback', this.checkedInfo);
      } else if (this.checkedInfo[0]) {
        const { id, name } = this.checkedInfo[0];
        this.$emit('selectLibCallback', id, name, this.ruleForm);
      }
    },

    // 兼容老的组件直接调用submit方法
    submit() {
      this.confirmLib();
    },

    close() {
      this.$emit('closeSelectLibDrawer');
    },

    getRowKey(row) {
      return row.id;
    },

    radioChange(item) {
      this.checkedInfo = (item && [item]) || [];
      this.ruleForm.pointLists = [];
    },

    selectionChange(val) {
      if (this.states.max && val.length > this.states.max) {
        this.checkedInfo = val.slice(0, this.states.max);

        // 剩余的题库选中为false
        const leftArr = val.slice(this.states.max);
        leftArr.forEach(item => {
          this.$refs.libTable.toggleRowSelection(item, false);
        });

        this.$message.warning(this.$t('pc_ote_msg_quesliblimitmax', [this.states.max]));
        return;
      }
      this.checkedInfo = val;
    },

    // 清空/删除选择的题库
    handleClose(info) {
      this.$nextTick(() => {
        if (this.needMutiple) {
          this.$refs.libTable.toggleRowSelection(info, false);
        } else {
          this.$refs.libTable.clearCurrentRadio();
        }
      });
    },

    // 清除所有题库
    clearAllQus() {
      this.$refs.libTable.clearSelection();
    },

    // 修改考核点radio
    changeRadioGroup() {
      this.ruleForm.pointLists = [];
    },

    save() {
      this.libDetail.btnDisabled = true;
      this.$refs.libEditor.save();
    },

    saveBtnStatus() {
      this.libDetail.btnDisabled = false;
    },

    // 打开新建题库
    openLibDetailDrawer() {
      this.libDetail.btnDisabled = false;
      this.libDetail.isShowDrawer = true;

      // 筛选了分类后进行赋值
      if (Object.keys(this.filterCatalog).length) {
        this.libDetail.catalogId = this.filterCatalog.id || this.ROOT_CATALOG_ID;
        this.libDetail.catalogName = this.filterCatalog.name;
      }
    },

    // 关闭新建试题库抽屉
    closeLibDrawer() {
      this.libDetail.isShowDrawer = false;
    },

    // 新建成功赋值
    setCreateVal(info) {
      // 不是复选 & 题库不被禁用 && 未选中某个题库
      if (!this.needMutiple && !info.catDisabled && !this.checkedInfo.length) {
        this.checkedInfo = [{ id: info.id, name: info.name }];

        // 如果catalog存在则处理下方数据
        if (info.catalogId) {
          this.params.catalogId = info.catalogId;
          this.params.catalogName = info.catalogName;
          if (info.changeCatalogInfo && Object.keys(info.changeCatalogInfo)) {
            this.filterCatalog = info.changeCatalogInfo;
            this.params.routingPath = info.changeCatalogInfo.routingPath;
          }
        }
      }

      this.search();
    }
  }
};
</script>
